interface Props {
  /** 0..1 */
  level: number;
  segments?: number;
  /** Gedämpfte Darstellung — z. B. für die Volume-Reihe. */
  dim?: boolean;
}

/**
 * 8-Segment-Pegelanzeige, horizontal. Aktive Segmente leuchten Amber,
 * inaktive bleiben dunkel. Wird oben auf jedem Panel-Button angezeigt.
 *
 * Mit `dim` werden aktive Segmente in einem ruhigeren Ton dargestellt —
 * gedacht für statische Werte wie die Kanal-Lautstärke unter dem Live-Meter.
 */
export function Meter({ level, segments = 8, dim = false }: Props): JSX.Element {
  const lit = Math.round(Math.max(0, Math.min(1, level)) * segments);
  const activeClass = dim ? 'bg-accent/50' : 'bg-meter-active';
  return (
    <div className="flex gap-0.5 w-full h-1.5">
      {Array.from({ length: segments }).map((_, i) => (
        <div
          key={i}
          className={[
            'flex-1 rounded-sm transition-colors',
            i < lit ? activeClass : 'bg-meter-idle',
          ].join(' ')}
        />
      ))}
    </div>
  );
}
